export interface Category {
  name: string;
  url: string;
  icon: string;
  seq: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    seq: 'cat-shoes',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20product%20photography%20of%20a%20single%20pair%20of%20cream%20white%20low-top%20sneakers%20on%20a%20warm%20beige%20linen%20surface%2C%20soft%20natural%20daylight%2C%20simple%20and%20elegant%20composition%2C%20warm%20neutral%20tone%2C%20editorial%20catalog%20style%20with%20gentle%20shadow&width=400&height=400&seq=cat-img-shoes-v2&orientation=squarish',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    seq: 'cat-hoodies',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20product%20photography%20of%20a%20neatly%20folded%20sage%20green%20hoodie%20on%20a%20warm%20beige%20surface%2C%20soft%20natural%20daylight%2C%20simple%20and%20elegant%20composition%2C%20warm%20neutral%20tone%2C%20editorial%20catalog%20style%20with%20gentle%20shadow&width=400&height=400&seq=cat-img-hoodies-v2&orientation=squarish',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    seq: 'cat-tshirts',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20product%20photography%20of%20a%20neatly%20folded%20crisp%20white%20t-shirt%20on%20a%20warm%20beige%20linen%20surface%2C%20soft%20natural%20daylight%2C%20simple%20and%20elegant%20composition%2C%20warm%20neutral%20tone%2C%20editorial%20catalog%20style%20with%20gentle%20shadow&width=400&height=400&seq=cat-img-tshirts-v2&orientation=squarish',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-hotel-line',
    seq: 'cat-jackets',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20product%20photography%20of%20a%20stylish%20tan%20bomber%20jacket%20folded%20neatly%20on%20a%20warm%20beige%20linen%20surface%2C%20soft%20natural%20daylight%2C%20simple%20and%20elegant%20composition%2C%20warm%20neutral%20tone%2C%20editorial%20catalog%20style%20with%20gentle%20shadow&width=400&height=400&seq=cat-img-jackets-v2&orientation=squarish',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    seq: 'cat-pants',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20product%20photography%20of%20neatly%20folded%20beige%20casual%20pants%20on%20a%20warm%20cream%20linen%20surface%2C%20soft%20natural%20daylight%2C%20simple%20and%20elegant%20composition%2C%20warm%20neutral%20tone%2C%20editorial%20catalog%20style%20with%20gentle%20shadow&width=400&height=400&seq=cat-img-pants-v2&orientation=squarish',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-riding-line',
    seq: 'cat-headwear',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20product%20photography%20of%20a%20simple%20cream%20colored%20baseball%20cap%20placed%20on%20a%20warm%20beige%20linen%20surface%2C%20soft%20natural%20daylight%2C%20simple%20and%20elegant%20composition%2C%20warm%20neutral%20tone%2C%20editorial%20catalog%20style%20with%20gentle%20shadow&width=400&height=400&seq=cat-img-headwear-v2&orientation=squarish',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    seq: 'cat-sets',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20product%20photography%20of%20a%20coordinated%20outfit%20set%20with%20a%20cream%20sweatshirt%20and%20matching%20beige%20joggers%20folded%20together%20on%20a%20warm%20linen%20surface%2C%20soft%20natural%20daylight%2C%20simple%20elegant%20composition%2C%20warm%20neutral%20tone%2C%20editorial%20catalog%20style&width=400&height=400&seq=cat-img-sets-v2&orientation=squarish',
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-user-3-line',
    seq: 'cat-underwear',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20product%20photography%20of%20neatly%20folded%20soft%20cotton%20underwear%20basics%20in%20neutral%20cream%20tones%20on%20a%20warm%20beige%20linen%20surface%2C%20soft%20natural%20daylight%2C%20simple%20and%20discreet%20composition%2C%20warm%20neutral%20tone%2C%20editorial%20catalog%20style&width=400&height=400&seq=cat-img-underwear-v2&orientation=squarish',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-football-line',
    seq: 'cat-jersey',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20product%20photography%20of%20a%20folded%20sports%20jersey%20in%20a%20neutral%20cream%20color%20with%20simple%20design%20on%20a%20warm%20beige%20linen%20surface%2C%20soft%20natural%20daylight%2C%20simple%20and%20elegant%20composition%2C%20warm%20neutral%20tone%2C%20editorial%20catalog%20style%20with%20gentle%20shadow&width=400&height=400&seq=cat-img-jersey-v2&orientation=squarish',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    seq: 'cat-accessories',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20product%20photography%20of%20a%20minimalist%20silver%20watch%20and%20simple%20leather%20bracelet%20arranged%20on%20a%20warm%20beige%20linen%20surface%2C%20soft%20natural%20daylight%2C%20simple%20elegant%20composition%2C%20warm%20neutral%20tone%2C%20editorial%20catalog%20style%20with%20gentle%20shadow&width=400&height=400&seq=cat-img-accessories-v2&orientation=squarish',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-shopping-bag-line',
    seq: 'cat-bags',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20product%20photography%20of%20a%20simple%20tan%20leather%20crossbody%20bag%20placed%20on%20a%20warm%20beige%20linen%20surface%2C%20soft%20natural%20daylight%2C%20simple%20and%20elegant%20composition%2C%20warm%20neutral%20tone%2C%20editorial%20catalog%20style%20with%20gentle%20shadow&width=400&height=400&seq=cat-img-bags-v2&orientation=squarish',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-links-line',
    seq: 'cat-belts',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20product%20photography%20of%20a%20simple%20brown%20leather%20belt%20coiled%20neatly%20on%20a%20warm%20beige%20linen%20surface%2C%20soft%20natural%20daylight%2C%20simple%20and%20elegant%20composition%2C%20warm%20neutral%20tone%2C%20editorial%20catalog%20style%20with%20gentle%20shadow&width=400&height=400&seq=cat-img-belts-v2&orientation=squarish',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-contrast-drop-line',
    seq: 'cat-perfumes',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20product%20photography%20of%20a%20simple%20elegant%20glass%20perfume%20bottle%20with%20warm%20amber%20liquid%20on%20a%20warm%20beige%20linen%20surface%2C%20soft%20natural%20daylight%2C%20simple%20and%20elegant%20composition%2C%20warm%20neutral%20tone%2C%20editorial%20catalog%20style%20with%20gentle%20shadow&width=400&height=400&seq=cat-img-perfumes-v2&orientation=squarish',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    seq: 'cat-other',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20product%20photography%20of%20a%20curated%20assortment%20of%20small%20lifestyle%20items%20including%20a%20simple%20keychain%20and%20notebook%20on%20a%20warm%20beige%20linen%20surface%2C%20soft%20natural%20daylight%2C%20simple%20and%20elegant%20composition%2C%20warm%20neutral%20tone%2C%20editorial%20catalog%20style%20with%20gentle%20shadow&width=400&height=400&seq=cat-img-other-v2&orientation=squarish',
  },
];

export const seoKeywords = [
  'vigorbuy spreadsheet 2026',
  'vigorbuy spreadsheet guide',
  'vigorbuy spreadsheet review',
  'vigorbuy spreadsheet link',
  'vigorbuy spreadsheet update',
  'best vigorbuy spreadsheet',
  'vigorbuy spreadsheet categories',
  'vigorbuy spreadsheet QC',
  'is vigorbuy spreadsheet safe',
];

export const mainSiteUrl = 'https://kaspreadsheet.com';